import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/search.svg'
import _imports_1 from '@/assets/icons/chevron-down.svg'


const _hoisted_1 = { class: "flex flex-col min-h-screen" }
const _hoisted_2 = { class: "flex-grow bg-background shadow-inner" }
const _hoisted_3 = { class: "container py-8" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_6 = { class: "flex flex-row justify-between items-center mb-4" }
const _hoisted_7 = { class: "flex flex-row items-center" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_9 = { class: "relative flex flex-row items-center" }
const _hoisted_10 = { class: "flex flex-row" }
const _hoisted_11 = { class: "mr-4 capitalize" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_13 = {
  key: 0,
  class: "absolute top-0 right-0 flex flex-col bg-white rounded mt-8 w-48 shadow"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  key: 1,
  class: "flex flex-col"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_ErrorState = _resolveComponent("ErrorState")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_IncomingTalent = _resolveComponent("IncomingTalent")!
  const _component_ActiveTalent = _resolveComponent("ActiveTalent")!
  const _component_InactiveTalent = _resolveComponent("InactiveTalent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Navbar),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_Spinner, { key: 0 }))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_ctx.error)
                ? (_openBlock(), _createBlock(_component_ErrorState, { key: 0 }))
                : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _hoisted_8,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
                          onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.filterSearch && _ctx.filterSearch(...args))),
                          type: "text",
                          placeholder: "Start typing to search talent...",
                          class: "apperance-none border-0 rounded bg-background p-4 w-72 focus:outline-none focus:ring-0"
                        }, null, 544), [
                          [_vModelText, _ctx.searchQuery]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("button", {
                          class: "mr-4",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openFilter = !_ctx.openFilter))
                        }, [
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.selectedFilter), 1),
                            _hoisted_12
                          ])
                        ]),
                        (_ctx.openFilter)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filters, (item, i) => {
                                return (_openBlock(), _createElementBlock("button", {
                                  key: i,
                                  class: "hover:bg-background-secondary rounded p-4 capitalize",
                                  onClick: ($event: any) => (_ctx.filterTalent(item))
                                }, _toDisplayString(item), 9, _hoisted_14))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    (_ctx.allTalent.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _createVNode(_component_EmptyState, { name: "talent" })
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.incomingMembers, (member, i) => {
                            return (_openBlock(), _createBlock(_component_IncomingTalent, {
                              key: i,
                              talent: member,
                              exchange_rate: _ctx.meta.mxn_to_usd_exchange_rate
                            }, null, 8, ["talent", "exchange_rate"]))
                          }), 128)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeMembers, (member, i) => {
                            return (_openBlock(), _createBlock(_component_ActiveTalent, {
                              key: i,
                              talent: member,
                              exchange_rate: _ctx.meta.mxn_to_usd_exchange_rate
                            }, null, 8, ["talent", "exchange_rate"]))
                          }), 128)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inactiveMembers, (member, i) => {
                            return (_openBlock(), _createBlock(_component_InactiveTalent, {
                              key: i,
                              talent: member
                            }, null, 8, ["talent"]))
                          }), 128))
                        ]))
                  ]))
            ]))
      ])
    ])
  ]))
}